import menuVar from "./src/menuVar";
export default Object.assign({},menuVar)